module.exports = __webpack_public_path__ + "static/media/bg_signin@2x.b254d0ae.png";